import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";
import moment from 'moment';

export default {
    getEstatesByGroupID,
    GetReportData,
    getCollectionPointsByOperationentityGroupID
};

async function getEstatesByGroupID(id) {
    var estateArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllEstateFilteredOperationEntityByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return estateArray;
}

async function getCollectionPointsByOperationentityGroupID(operationEntityID, groupID) {
    var collectionPointArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["operationEntityID"] === parseInt(operationEntityID) && item[1]["groupID"] === parseInt(groupID) && item[1]["isActive"] === true) {
            collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return collectionPointArray;
}

async function GetReportData(operationEntityID, month) {
    var newModel = {
        operationEntityID: parseInt(operationEntityID),
        year: parseInt(moment(month).format('YYYY')),
        month: parseInt(moment(month).format('MM'))
    }
    const response = await CommonPost('/api/DailyCropSummaryTeaReport/GetDailyCropSummaryTeaReport', null, newModel);
    return response.data;
}

